/*
hdx-bootstrap.js

-GE CONFIDENTIAL-
Type: Source Code

Copyright (c) 2021, GE Healthcare Co.
All Rights Reserved

This unpublished material is proprietary to GE Healthcare. The methods and
techniques described herein are considered trade secrets and/or
confidential. Reproduction or distribution, in whole or in part, is
forbidden except by express written permission of GE Healthcare.
*/

define(
    'modules/shell/hdx/components/hdx-bootstrap/js/hdx-bootstrap',[
        'jquery',
        'bootstrap/affix',
        'bootstrap/alert',
        'bootstrap/button',
        'bootstrap/modal',
        'bootstrap/scrollspy',
        'bootstrap/tab',
        'bootstrap/tooltip',
        'bootstrap/transition',
        'bootstrap/carousel',
        'bootstrap/collapse',
        'bootstrap/dropdown',
        'bootstrap/popover',
        './hdx-bootstrap/accordion',
        './hdx-bootstrap/modal'
    ], function ($) {
        $.fn.btooltip = $.fn.tooltip;
        'use strict';
        return $;
    }
);

